const childRoutes = (prop) => [
    {
        path: 'prepare-notice',
        name: prop + '.prepare_notice',
        meta: { auth: true },
        component: () => import('../pages/prepare-notice/List')
    },
     {
        path: 'archiving',
        name: prop + '.archiving',
        meta: { auth: true },
        component: () => import('../pages/archiving/List')
    },
      {
        path: 'dashboard',
        name: prop + '.dashboard',
        meta: { auth: true },
        component: () => import('../pages/dashboard/List')
    },
    {
        path: 'notice-recommendation-approval',
        name: prop + '.notice_recommendation_approval',
        meta: { auth: true },
        component: () => import('../pages/notice-recommendation-approval/List')
    },
    {
        path: 'application-list',
        name: prop + '.application_list',
        meta: { auth: true },
        component: () => import('../pages/application-list/List')
    },
    {
        path: 'review-verification-management',
        name: prop + '.review_verification_management',
        meta: { auth: true },
        component: () => import('../pages/review-verification-management/List')
    },
    {
        path: 'registration-approval',
        name: prop + '.registration_approval',
        meta: { auth: true },
        component: () => import('../pages/registration-approval/List')
    }
]

const routes = [{
    path: '/grant-allowance-service/registration-management',
    name: 'grant_allowance_service.registration_management',
    component: () => import('@/layouts/GrantAllowanceLayout.vue'),
    meta: { auth: true },
    children: childRoutes('grant_allowance_service.registration_management')
}]
export default routes
